import React from 'react';
import { connect } from 'react-redux';
import { api } from "api";
import { renderField, renderSearchSelectPatient, renderSwitch } from 'Utils/renderField/renderField';
import { Field, reduxForm } from 'redux-form';

const getPatients = (search) => {
  return api.get("patients", {search}).catch((error) => {})
      .then((data) => {
          if (data){
              const patients = [];
              data.results.forEach(x=>{
                  patients.push({value: x.id, label: x.first_name + " " + x.last_name})
              })
              return patients
          }
          else{
              return []
          }
      })
      .catch(e => {
          return []
      })
}

const PatientAppointmentSurgeryForm = props =>  {  
    const { 
      inSearchGoToWeek,
      cancel,      
      patient_appointments_list,      
      getPatientAppointments,
      clearPatientAppointments,
      handleSubmit
    } = props;

    const onSubmitForm = (values) => {
      getPatientAppointments(values);
    }

    return(
      <React.Fragment>
      <form 
        //onSubmit={(e) => { e.preventDefault(); getPatientAppointments();}}
        onSubmit={handleSubmit(onSubmitForm)}
      >                          
        <div className="m-2">          
          <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
              <label htmlFor="person" className="">Buscar y seleccionar paciente</label>
          </div>
          <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
              <Field
                  name="patient_search"
                  valueKey="value"
                  labelKey="label"
                  label="name"
                  component={renderSearchSelectPatient}
                  loadOptions={getPatients}
                  className="no-border"                  
              />
          </div>    
        </div>                
          
          <div className="row-fluid my-3">
              <div className="d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-around">
                  <a className="btn btn-small btn-secondary" onClick={cancel}>Cancelar</a>
                  <button
                    type="submit"
                    className="btn btn-small btn-primary"
                    //onClick={()=> this.searchInfo()}
                  >Buscar</button>
              </div>
          </div>
      </form>

      {patient_appointments_list && patient_appointments_list.length > 0 &&
      <div className='d-flex flex-column align-middle'>
        <span className='d-flex flex-row justify-content-center'>Consultas del (la) paciente:</span>
        {patient_appointments_list.map(appointment => (
          <button 
            className='d-flex flex-row justify-content-center new-link-hover'
            style={{
              textDecoration: 'none',
              color: '#000',
              fontWeight: 700
            }}
            onClick={() => inSearchGoToWeek(appointment.date.split("-").reverse().join("/"))}
          >{appointment.date.split("-").reverse().join("/")}</button>
        ))}

        <div className='d-flex flex-row justify-content-center mt-2'>
          <button onClick={() => clearPatientAppointments()} className='btn btn-xs btn-success' style={{ fontSize: '12px' }}>Nueva búsqueda</button>
        </div>
      </div>      
      }
      </React.Fragment>
    )  
}

const custom_validate = values => {
  const errors = {};  
  console.log("VALUES IN CUSTOM VALIDATE SEARCH TAB SURGERY .::: ", values);
  if (values.patient_search === undefined || values.patient_search === null) {
      errors.patient_search = 'Campo requerido';
  }
  
  return errors;
};

let SearchTabSurgery = reduxForm({
  form: 'patient_appointments_surgery',
  validate: custom_validate
})(PatientAppointmentSurgeryForm);

export default SearchTabSurgery